/**
 * Debounce (дебаунс) — это техника, которая откладывает выполнение функции до тех пор,
 * пока не пройдет определенный промежуток времени с момента последнего вызова.
 * Если функция вызывается снова в течение этого времени, таймер сбрасывается.
 * Это полезно, когда вы хотите, чтобы функция выполнялась только после того,
 * как пользователь закончит ввод или взаимодействие.
*/
const debounce = (func, wait) => {
    let timeout = null;
    return (...args) => {
        if (timeout)
            clearTimeout(timeout);
        timeout = setTimeout(() => {
            func(...args);
        }, wait);
    };
};
export default debounce;
// JavaScript вариант:
// const debounce = (func, delay) => {
//   let timeout;
//   return (...args) => {
//     clearTimeout(timeout);
//     timeout = setTimeout(() => func.apply(this, args), delay);
//   };
// };
// Пример использования:
// debounceBtn.addEventListener('click', debounce(function() {
//   console.info('Hey! It is', new Date().toUTCString());
// }, 3000));
// или
// window.addEventListener("scroll", debounce(handleScroll, 300));
